import { ClassName } from "utils/custom.types"

/**
 *
 * @param classes a list of strings
 * @returns a single class name with all the strings concatenated
 * @example
 * import clsx from 'utils/clsx'
 *
 * clsx("foo", false && "bar") // returns "foo"
 * @author Malik Bagwala <malik.bagwala@vesatogo.com>
 */
function clsx(...classes: (string | boolean | null | undefined)[]) {
  if (!classes.length) return null
  const filtered = classes.filter(cls => cls && typeof cls === "string")
  if (!filtered.length) return null
  return filtered.join(" ")
}

export function extendClasses(className: ClassName) {
  if (!className) return []
  return Array.isArray(className) ? className : [className]
}
export default clsx
